<div class="chat-view-container dark-chat" [class.overlay-transparent]="isOverlayMode">

     <!-- Coach cue overlay — centered in header -->
     <div *ngIf="activeCoachCue" class="coach-cue-overlay" [@coachCueAnim]>
          <span class="coach-cue-emoji-box">
               <span *ngIf="activeCoachCueSvgHtml" class="coach-cue-svg" [innerHTML]="activeCoachCueSvgHtml"></span>
               <span *ngIf="!activeCoachCueSvgHtml" class="coach-cue-emoji">{{ activeCoachCue.emoji }}</span>
          </span>
          <span class="coach-cue-label">{{ activeCoachCue.label }}</span>
     </div>

     <!-- If the link is expired -->
     <div *ngIf="isLinkExpired" class="expired-link-container"
          style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:80vh;">
          <mat-icon style="font-size:64px;color:#f7971e;margin-bottom:24px;">link_off</mat-icon>
          <h1 style="margin-bottom:12px;font-size:2.2rem;font-weight:600;color:#e4e4ed;text-align:center;">Your link has
               expired</h1>
          <p style="font-size:1.25rem;color:#9e9e9e;text-align:center;margin-bottom:24px;">Please contact admin to create a
               new Interview link.</p>
     </div>
     <!-- If the link is valid, show chat messages -->
     <div *ngIf="!isLinkExpired" class="chat-body">
          <div class="main-header">
               <span class="app-name">Otter AI</span>

               <!-- Desktop: interview code & live mode inline -->
               <div class="interview-code desktop-only">
                    <span>Interview Code:</span>
                    <span class="code">{{ templateId }}</span>
               </div>
               <div class="interview-mode desktop-only">
                    <span class="mode">{{ isCodingConversation(currentConversation$ | async) ? 'Coding mode' : 'Live Interview mode' }}</span>
               </div>

               <span class="spacer"></span>

               <!-- Right group: auto scroll + zoom — always visible -->
               <div class="header-right-group">
                    <label class="custom-chip">
                         <input type="checkbox" [(ngModel)]="autoScrollEnabled" (change)="onAutoScrollToggle()">
                         <span>Auto Scroll</span>
                    </label>
                    <div class="custom-select-wrapper" *ngIf="autoScrollEnabled">
                         <button type="button" class="custom-select-trigger" (click)="toggleIntervalDropdown($event)">
                              {{ autoScrollIntervalSeconds }}s
                              <mat-icon>arrow_drop_down</mat-icon>
                         </button>
                         <ul class="custom-select-options" *ngIf="intervalDropdownOpen">
                              <li *ngFor="let sec of autoScrollOptions"
                                   [class.selected]="sec === autoScrollIntervalSeconds"
                                   (click)="selectInterval(sec, $event)">
                                   {{ sec }}s
                              </li>
                         </ul>
                    </div>
                    <div class="zoom-controls">
                         <button type="button" class="zoom-btn" (click)="onZoomOut()" title="Zoom out">
                              <mat-icon>remove</mat-icon>
                         </button>
                         <button type="button" class="zoom-btn" (click)="onZoomIn()" title="Zoom in">
                              <mat-icon>add</mat-icon>
                         </button>
                    </div>
               </div>

               <!-- Menu toggle — only interview code & live mode inside -->
               <div class="menu-dropdown-wrapper" #menuDropdown>
                    <mat-icon class="menu-toggle-btn" (click)="menuOpen = !menuOpen"
                         aria-label="Toggle menu">more_vert</mat-icon>
                    <div class="toggle-menu-items" *ngIf="menuOpen" [class.show]="menuOpen">
                         <div class="interview-code">
                              <span>Interview Code:</span>
                              <span class="code">{{ templateId }}</span>
                         </div>
                         <div class="interview-mode">
                              <span class="mode">{{ isCodingConversation(currentConversation$ | async) ? 'Coding mode' : 'Live Interview mode' }}</span>
                         </div>
                    </div>
               </div>
          </div>

          <div class="chat-scroll-area">
               <div class="chat-messages-container" #scrollContainer #zoomContainer (scroll)="onScroll()">
                    <ng-container *ngIf="currentConversation$ | async as conv">
                      <div *ngIf="conv.messages.length === 0" class="no-history-message" style="text-align:center;padding:48px 0;font-size:1.2rem;">
                        <div>There is no chat history yet.</div>
                      </div>
                      <div *ngFor="let msg of conv.messages" class="message-wrapper" [ngClass]="msg.sender">
                        <div class="message-card">
                          <div class="message-header">
                            <mat-icon class="chat-icon">{{ msg.sender === 'bot' ? 'chat' : 'group' }}</mat-icon>
                            <p class="sender-label">{{ msg.sender === 'bot' ? 'Otter AI' : 'You' }}</p>
                            <p class="msg-time">{{ msg.timestamp | date : 'MMM d, y, h:mm a' }}</p>
                            <mat-icon class="mat-icon-copy" [class.animate-copied]="msg.copied"
                              (click)="copyToClipboard(msg)"
                              matTooltip="{{ msg.copied ? 'Copied!' : 'Copy link' }}">
                              {{ msg.copied ? 'check_circle' : 'content_copy' }}
                            </mat-icon>
                          </div>
                          <div class="message-body" *ngIf="isCodingAnswer(msg.text); else learnerMarkdown">
                            <app-coding-answer [text]="msg.text" theme="dark"></app-coding-answer>
                          </div>
                          <ng-template #learnerMarkdown>
                            <div class="message-body" [innerHTML]="formatMessage(msg.text, msg)"></div>
                          </ng-template>
                        </div>
                      </div>
                    </ng-container>
                    <button class="scroll-to-bottom-btn chatgpt-arrow"
                         [class.hidden-arrow]="isNearBottom || autoScrollAnimating"
                         (click)="onScrollToBottomClick()" [class.streaming]="isStreaming" title="Scroll to bottom">
                         <mat-icon>arrow_downward</mat-icon>
                    </button>
               </div>
               <div class="zoom-indicator" *ngIf="showZoomIndicator" title="Click to reset zoom">
                    Zoom: {{ zoomDisplayValue }}
               </div>
          </div>
     </div>

     <style>
          .attachment-preview-card button mat-icon:hover { color: #e53935 !important; }
          .expired-link-message { text-align: center; font-size: 1.5rem; color: #ff5722; margin-top: 20px; }
          .chat-messages-container { padding-bottom: 18rem; }
          .scroll-to-bottom-btn { position: fixed; right: 18px; bottom: 100px; z-index: 1200; background: transparent; border: none; padding: 0; cursor: pointer; }
          .chatgpt-arrow { width: 34px; height: 34px; border-radius: 17px; display: flex; align-items: center; justify-content: center; background: #818cf8; color: white; box-shadow: 0 4px 12px rgba(0,0,0,0.4); transition: transform 160ms ease, box-shadow 160ms ease, opacity 160ms ease, visibility 160ms ease; opacity: 1; visibility: visible; }
          .chatgpt-arrow.hidden-arrow { opacity: 0; visibility: hidden; pointer-events: none; }
          .chatgpt-arrow mat-icon { font-size: 18px; width: 18px; height: 18px; line-height: 18px; }
          /* Small windows: 100px up is mid-answer, so the arrow moves to the corner and shrinks. */
          @media (max-width: 520px), (max-height: 420px) {
               .scroll-to-bottom-btn { right: 12px; bottom: 14px; }
               .chatgpt-arrow { width: 28px; height: 28px; border-radius: 14px; }
               .chatgpt-arrow mat-icon { font-size: 15px; width: 15px; height: 15px; line-height: 15px; }
          }
          .chatgpt-arrow:hover { transform: translateY(-4px); box-shadow: 0 10px 24px rgba(0,0,0,0.5); }
          .chatgpt-arrow.streaming { animation: chat-pulse 1.6s infinite; }
          @keyframes chat-pulse {
               0% { box-shadow: 0 4px 12px rgba(0,0,0,0.4); transform: scale(1); }
               50% { box-shadow: 0 8px 20px rgba(0,0,0,0.3); transform: scale(1.06); }
               100% { box-shadow: 0 4px 12px rgba(0,0,0,0.4); transform: scale(1); }
          }
     </style>
